/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { QnaMakerProjectCreationPayloadSwagger, QnaMakerProjectSwagger } from 'src/qnaMaker/core/services/qnaMakerProjectSwaggers';
import { QnaMakerProjectStore } from 'src/qnaMaker/core/stores/QnaMakerProjectStore';
import { QnaMakerLanguage } from 'src/qnaMaker/core/types/QnaMakerLanguages';
import { QnaMakerProjectDto } from 'src/qnaMaker/verticals/qnaMakerProjectCreationModal/QnaMakerProjectCreationModal';

export const qnaMakerProjectSwaggerToStore = (projectSwagger: QnaMakerProjectSwagger): QnaMakerProjectStore =>
    new QnaMakerProjectStore(projectSwagger.projectName, {
        ...projectSwagger,
        name: projectSwagger.projectName,
        defaultAnswer: projectSwagger.settings.defaultAnswer,
        createdDate: new Date(projectSwagger.createdDateTime),
        lastPublishedDate: projectSwagger.lastDeployedDateTime ? new Date(projectSwagger.lastDeployedDateTime) : null,
        modifiedDate: new Date(projectSwagger.lastModifiedDateTime),
        language: <QnaMakerLanguage>projectSwagger.language
    });

export const qnaMakerProjectStoreToSwagger = (projectStore: QnaMakerProjectStore): QnaMakerProjectSwagger => ({
    projectName: projectStore.name,
    description: projectStore.description,
    multilingualResource: projectStore.multilingualResource,
    language: projectStore.language,
    settings: { defaultAnswer: projectStore.defaultAnswer },
    createdDateTime: projectStore.createdDate.toString(),
    lastDeployedDateTime: projectStore.lastPublishedDate?.toString(),
    lastModifiedDateTime: projectStore.modifiedDate.toString()
});

export const qnaMakerProjectDtoToPayloadSwagger = (projectDto: QnaMakerProjectDto): QnaMakerProjectCreationPayloadSwagger => ({
    ...projectDto,
    projectName: projectDto.name,
    settings: { defaultAnswer: projectDto.defaultAnswer }
});
